import React from 'react';
import { RadioGroup, FormControlLabel, Radio} from '@material-ui/core';
import ComplexDescription from '../../complexDescription/.mixins/complexDescription';
export default function MultiSelectRadio(props) {
    const { idRadioChecked, itensModal, handleChange, SecondaryDescription } = props;

    return (
        <RadioGroup
            aria-label='opção'
            onChange={handleChange}
            value={idRadioChecked}
        >
            {itensModal.map((element, i) => (
                <FormControlLabel
                    value={element.id}
                    key={i}
                    control={<Radio />}
                    label={
                    <ComplexDescription 
                        element={element}
                        SecondaryDescription={SecondaryDescription}
                    />}
                />

            ))}
        </RadioGroup>
    );
}
